import {initCounter} from '$c3local/counter.js';
import {initMarquee} from '$c3local/marquee.js';
import {initHeaderButtons} from '$c3local/header.js';
import {initFilters} from '$c3local/recruiting.js';
import {initAnimations} from '$c3local/animation.js';
import {initSliders} from '$c3base/swiper.js';
import {initAccordions} from '$c3base/accordion-v2.js';

initSliders().catch(console.log);
initCounter();
initMarquee();
initHeaderButtons();
initFilters();
initAnimations().catch(console.error);
initAccordions();

import('$c3base/photoswipe.js')
    .then(({init}) => init());


document.querySelectorAll('.news-list').forEach(list => {
    const listWrap = list.querySelector('.news-list-items');
    const filterForm = list.querySelector(`.news-list-filter`);
    const pageInput = list.querySelector('[name="tx_c3news_newslist[page]"]');

    let page = 1;

    function loadMore(evt) {
        evt.preventDefault();
        evt.target.classList.add('is-loading');

        const lastPage = parseInt(evt.target.dataset.lastPage);
        page++;
        pageInput.setAttribute("value",page.toString());
        const data = new FormData(filterForm);
        fetch(filterForm.action, {method: 'post', body: data})
            .then(res => res.text())
            .then(res => {
                const tmp = document.createElement('template');
                tmp.innerHTML = res;
                const items = tmp.content.querySelector('#items').content.querySelectorAll('.news');
                for (const item of items) {
                    listWrap.append(item);
                }
            });

        if (page === lastPage) {
            evt.target.remove();
        }
    }

    if (location.search) {
        const url = new URL(location);
        const category = url.searchParams.get('category');
        if (category) {
            document.querySelector(`[name="tx_c3news_newslist[filter][category]"][value="${category}"]`).checked = true;
            document.querySelector(`.news-list-filter`).dispatchEvent(new CustomEvent('change'));
        }
    }

    list.addEventListener('c3news:list:update', () => {
        page = 1;
        const paginationBtn = list.querySelector('.load-more');
        paginationBtn?.addEventListener('click', loadMore);
    });

    list.querySelectorAll('.load-more').forEach(lm => lm.addEventListener('click', loadMore));
});

document.querySelectorAll('.page-stoerer').forEach((st, idx) => {
    if (getCookie(st.id)) st.remove();

    st.querySelector('.close').addEventListener('click', function () {
        let date = new Date();
        date.setTime(date.getTime() + (12 * 60 * 60 * 1000));
        document.cookie = st.id + '=1;expires=' + date.toUTCString() + ';';
        st.remove();
    });
});

for (const funnel of document.querySelectorAll('content-funnel')) {
    const style = document.createElement('style');
    style.innerHTML = `
        .cta {
            padding-left: 5rem !important;
            align-items: flex-end;
        }
    `;
    funnel.shadowRoot.append(style);
}

function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

const content_funnel = document.querySelector('content-funnel');
const page_stoerer = document.querySelector('.page-stoerer');

if (content_funnel !== null && page_stoerer !== null) {
    page_stoerer.classList.add('position_2');
}
